import { Currency } from "src/app/shared/constants/currencies";
import { EntityStatus } from "src/app/shared/constants/entity-status";
import { Option } from "src/app/shared/interfaces/form-fields";

// Transaction Reason
export enum TransactionReason {
  LOOK_UP_CHARGE = 1,
  RECONCILLIATION_BONUS = 2,
  PAYMENTS = 3,
  FEES = 4,
  WALLET_TRANSACTION = 5,
  PENALTY = 6,
  OTHER_TRANSACTIONS = 7
}

export const TRANSACTION_REASONS = [
  { label: 'Look Up Charge', value: TransactionReason.LOOK_UP_CHARGE },
  { label: 'Reconcilliation Bonus', value: TransactionReason.RECONCILLIATION_BONUS },
  { label: 'Payment', value: TransactionReason.PAYMENTS },
  { label: 'Fees', value: TransactionReason.FEES },
  { label: 'Wallet Transaction', value: TransactionReason.WALLET_TRANSACTION },
  { label: 'Penalty', value: TransactionReason.PENALTY },
  { label: 'Other Transactions', value: TransactionReason.OTHER_TRANSACTIONS }
];

export const getTransactionReason = (reason: TransactionReason): string => {
  switch (reason) {
    case TransactionReason.LOOK_UP_CHARGE:
      return 'Look Up Charge';
    case TransactionReason.RECONCILLIATION_BONUS:
      return 'Reconcilliation Bonus';
    case TransactionReason.PAYMENTS:
      return 'Payment';
    case TransactionReason.FEES:
      return 'Fees';
    case TransactionReason.WALLET_TRANSACTION:
      return 'Wallet Transaction';
    case TransactionReason.PENALTY:
      return 'Penalty';
    case TransactionReason.OTHER_TRANSACTIONS:
      return 'Other Transactions';
    default:
      return '-';
  }
};
    
// Transaction Type
export enum TransactionType {
  CREDIT = 1,
  DEBIT = 2,
  LOOKUP_TRANSACTION = 3,
  SERVICE_TRANSACTION = 4
}

export const TRANSACTION_TYPES: Option[] = [
  { label: 'Credit', value: TransactionType.CREDIT },
  { label: 'Debit', value: TransactionType.DEBIT },
  { label: 'Lookup Transaction', value: TransactionType.LOOKUP_TRANSACTION },
  { label: 'Service Transaction', value: TransactionType.SERVICE_TRANSACTION }
];

export const getTransactionType = (type: TransactionType): string => {
  switch (type) {
    case TransactionType.CREDIT:
      return 'Credit';
    case TransactionType.DEBIT:
      return 'Debit';
    case TransactionType.LOOKUP_TRANSACTION:
      return 'Lookup Transaction';
    case TransactionType.SERVICE_TRANSACTION:
      return 'Service Transaction';
    default:
      return '-';
  }
};

export enum TransactionPaymentMethod {
  BANK_TRANSFER = 1,
  WALLET = 2
}

export enum SettlementReason{
  PAYMENT = 1,
  DISCOUNT = 2,
  PENALTY = 3,
  OTHER_TRANSACTION = 4
}

export enum ClientPaymentCategory {
  PREPAID = 1,
  POSTPAID = 2
}

export interface IClientWallet {
  walletName: string;
  clientId: string;
  currency: Currency;
  balance: number;
  serviceProviderId: string;
  walletStatus: number;
  creditLimit: number;
  threshold: number;
  entityStatus: EntityStatus;
  billingCycles: number;
  clientPaymentCategory: ClientPaymentCategory;
  id: string;
  createdAt: Date;
  lastUpdatedAt: Date;
}

export interface IClientWalletTopUp {
  amount: number;
  walletId: string;
  reason: SettlementReason;
  transactionType: TransactionType;
  clientServiceId?: string;
  transactionNote?: string;
}

export interface IUpdateClientWallet {
  walletName: string;
  creditLimit: number;
  threshold: number;
}